import config from "../../config/config";

import helper from "../../helper/helpers";

// const copyUrlToClipboard = () => { // TODO - Copy strack trace on error to developers
/*
    var dummy = document.createElement('input'),
        text = window.location.href;
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
     */
//navigator.clipboard.writeText(window.location.href);
// }

const setupVisualClickAreaAndGetCount = (returnElements) => {
	const attatchClass = (element) => {
		try {
			element.classList.add("showclickarea");
			countElements++;
			element.focus();
		} catch {
			console.log("Could not attatch visual click area on element: ", element);
		}
	};

	let countElements = 0;
	if (returnElements)
		returnElements.constructor === Array ? returnElements.map(attatchClass) : attatchClass(returnElements);
	return countElements;
};

export default (returnElements, gizmoData) => {
	if (helper.allowedToRun() && window.location.href.indexOf(config.checkClickTrackerParam) > -1) {
		let content = "";
		let version = gizmoData && gizmoData.testIndex >= 0 ? "Version " + config.versionLetters[gizmoData.testIndex] : "";
		let testType = gizmoData.testType === 1 ? "Component test" : "Link test";
		let elementCount = setupVisualClickAreaAndGetCount(returnElements);

		if (!returnElements)
			content =
				"<h2>" +
				testType +
				" for " +
				version +
				"</h2>" +
				"<h2>A/B Test Tracking Status: Error!</h2>" +
				"<p>It looks to be something wrong with the link triggers for this A/B Test.</p>" +
				"<p>The click element(s) could not be found on the page.</p>" +
				"<p><b>If something on the page is still loading, wait a bit and see if it manage to detect the link trigger after it has finished loading everything.</b></p>" +
				"<p>If that don't work try to select it again in Gizmo, publish the page and preform a new check.</p>";
		else
			content =
				"<h2>" +
				testType +
				" for " +
				version +
				"</h2>" +
				"<h2>A/B Test Tracking Status: Success!</h2>" +
				"<p>We found <b>" +
				elementCount +
				" A/B Test link triggers</b>, now shown on page with red borders.</p>" +
				"<p>Click data should be sent to Adobe and show up in Gizmo when link trigger are clicked!</p>";

		let isSuccess = returnElements;
		let popup = document.getElementById(config.popupId);
		if (!popup) {
			const newDiv = document.createElement("div");
			newDiv.id = config.popupId;
			newDiv.classList.add("abtest-popup");
			if (isSuccess) newDiv.classList.add("success");
			const newContent = document.createTextNode("");
			newDiv.appendChild(newContent);
			newDiv.innerHTML = content;
			document.getElementsByTagName("body")[0].appendChild(newDiv);

			let styleString =
				".abtest-popup { " +
				"position: fixed;" +
				"bottom: 0;" +
				"left: 0;" +
				"background: #920000;" +
				"color: white;" +
				"width: 700px;" +
				"padding: 20px;" +
				"z-index: 999;" +
				"border-radius: 0 20px 0 0; " +
				"}" +
				".abtest-popup h2 { " +
				"font-size: 30px;" +
				"margin-bottom: 20px;" +
				"}" +
				".abtest-popup p { " +
				"margin-bottom: 10px;" +
				"}" +
				".abtest-popup b {" +
				"font-weight: bold" +
				"}" +
				".abtest-popup.success {" +
				"background: green;" +
				"}" +
				".showclickarea { " +
				"border: 5px dashed red !important; " +
				"}";
			const style = document.createElement("style");
			style.textContent = styleString;
			document.head.append(style);
		} else {
			popup.innerHTML = content;
			if (!isSuccess && popup.classList.contains("success")) popup.classList.remove("success");
			else popup.classList.add("success");
		}
	}
};
